module.exports = __webpack_public_path__ + "img/file-bar-graph-fill.556c5eef.svg";